import React, { useEffect, useRef, useState } from 'react'

import { downloadRhImportTemplate } from '../../api/index'

import styles from './RhTemplateMenu.module.css'

import btnStyles from '../ImportMensuel/ImportMensuel.module.css'



const MONTHS = [

  '', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',

  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',

]



const getPreviousPeriodLabel = (month, year) => {

  let prevMonth = month - 1

  let prevYear = year

  if (prevMonth < 1) {

    prevMonth = 12

    prevYear -= 1

  }

  return `${MONTHS[prevMonth]} ${prevYear}`

}



const extractFilename = (contentDisposition, fallback) => {

  const match = contentDisposition?.match(/filename="([^"]+)"/)

  return match?.[1] || fallback

}



const FALLBACK_FILENAMES = {

  sage: 'modele-import-sage-coaches.xlsx',

  regime: 'modele-import-regime-coaches.xlsx',

  coaches: 'modele-import-regime-coaches.xlsx',

  previous: 'modele-import-rh-reprise.xlsx',

  empty: 'modele-import-rh-vide.xlsx',

}



const getDownloadErrorMessage = async (error) => {

  const blob = error?.response?.data

  if (blob instanceof Blob) {

    try {

      const parsed = JSON.parse(await blob.text())

      if (parsed?.message) return parsed.message

    } catch {

      // ignore parse errors

    }

  }

  return error?.response?.data?.message

    || (error?.response?.status === 404

      ? 'Modèle indisponible pour cette période'

      : 'Erreur téléchargement du modèle Excel')

}



const RhTemplateMenu = ({ month, year, onError, onSuccess, className = '' }) => {

  const [open, setOpen] = useState(false)

  const [downloading, setDownloading] = useState(false)

  const menuRef = useRef(null)



  useEffect(() => {

    if (!open) return undefined



    const handleClickOutside = (event) => {

      if (menuRef.current && !menuRef.current.contains(event.target)) {

        setOpen(false)

      }

    }



    document.addEventListener('mousedown', handleClickOutside)

    return () => document.removeEventListener('mousedown', handleClickOutside)

  }, [open])



  const handleDownload = async (type) => {

    setDownloading(true)

    setOpen(false)



    try {

      const response = await downloadRhImportTemplate({

        type,

        month: type === 'previous' ? month : undefined,

        year: type === 'previous' ? year : undefined,

      })



      const filename = extractFilename(

        response.headers['content-disposition'],

        FALLBACK_FILENAMES[type] || FALLBACK_FILENAMES.empty

      )

      const url = window.URL.createObjectURL(new Blob([response.data]))

      const link = document.createElement('a')

      link.href = url

      link.download = filename

      link.click()

      window.URL.revokeObjectURL(url)

      onSuccess?.(type)

    } catch (error) {

      onError?.(await getDownloadErrorMessage(error))

    } finally {

      setDownloading(false)

    }

  }



  const previousLabel = getPreviousPeriodLabel(month, year)



  return (

    <div className={`${styles.menu} ${className}`} ref={menuRef}>

      <button

        type="button"

        className={`${btnStyles.secondaryBtn} ${styles.trigger}`}

        onClick={() => setOpen((value) => !value)}

        disabled={downloading}

        aria-haspopup="menu"

        aria-expanded={open}

      >

        {downloading ? 'Téléchargement…' : 'Modèle Excel RH'}

        <span className={styles.chevron} aria-hidden="true">▾</span>

      </button>



      {open && (

        <div className={styles.dropdown} role="menu">

          <button

            type="button"

            className={styles.option}

            role="menuitem"

            disabled={downloading}

            onClick={() => handleDownload('sage')}

          >

            <span className={styles.optionTitle}>

              Auto-entrepreneurs (export Sage)

              <span className={styles.recommended}>Recommandé</span>

            </span>

            <span className={styles.optionHint}>

              Matricule Sage, Prénom, Nom, Net à payer (Sage) — la facture ajoute +1 TND de timbre.

            </span>

          </button>

          <button

            type="button"

            className={styles.option}

            role="menuitem"

            disabled={downloading}

            onClick={() => handleDownload('regime')}

          >

            <span className={styles.optionTitle}>Régime réel / forfaitaire</span>

            <span className={styles.optionHint}>

              Matricule fiscal + honoraires variable/fixe. TVA, retenue et total depuis la fiche coach.

            </span>

          </button>

          <button

            type="button"

            className={styles.option}

            role="menuitem"

            disabled={downloading}

            onClick={() => handleDownload('previous')}

          >

            <span className={styles.optionTitle}>Reprendre {previousLabel}</span>

            <span className={styles.optionHint}>

              Deux feuilles : Sage (auto-entrepreneurs) et Régime — honoraires du mois précédent recopiés.

            </span>

          </button>

          <button

            type="button"

            className={styles.option}

            role="menuitem"

            disabled={downloading}

            onClick={() => handleDownload('empty')}

          >

            <span className={styles.optionTitle}>Modèle vide</span>

            <span className={styles.optionHint}>Exemples des deux formats (Sage + Régime).</span>

          </button>

        </div>

      )}

    </div>

  )

}



export default RhTemplateMenu

